import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { axiosInstance } from "../../../config/axios-config";
import { MoveItemInvite } from "./MoveItemInvite";
import { VisitorInvite } from "./VisitorInvite";
import { NotFound } from "./404Page";

const InviteType = {
  Visitor: "visitor_invite",
  MoveItem: "move-item",
};

async function getVisitorInviteData(id) {
  return axiosInstance
    .get(`/visitors/booking/id/${id}/public`)
    .then((r) => r.data);
}

function getMoveInviteData(id) {
  return axiosInstance.get(`/move-requests/public/${id}`).then((r) => r.data);
}

export function InvitePage(props) {
  const { id } = useParams();
  const { search } = useLocation();
  const type = new URLSearchParams(search).get("type");
  const addToTrybzLink = new URLSearchParams(search).get("add_to_trybz");
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    let promise;
    switch (type) {
      case InviteType.MoveItem:
        promise = getMoveInviteData(id);
        break;

      default:
        promise = getVisitorInviteData(id);
        break;
    }

    promise
      .catch((err) => {
        if (err.response?.status === 404) return null;
        else throw err;
      })
      .then((result) => {
        setData(result);
        setLoading(false);
      });
  }, [id, type]);

  if (isLoading) {
    return (
      <div className="tw-grid tw-h-screen tw-place-content-center">
        <CircularProgress />
      </div>
    );
  }

  if (!data) {
    return <NotFound />;
  }

  switch (type) {
    case InviteType.MoveItem:
      return <MoveItemInvite data={data} />;

    default:
      return <VisitorInvite data={data} addToTrybzLink={addToTrybzLink} />;
  }
}
